<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_19815_43657)">
      <path
        d="M13.8243 16.0007L6.57191 8.74833C6.26368 8.44011 6.10969 8.07749 6.10993 7.66048C6.10993 7.24322 6.26405 6.88048 6.57227 6.57226C6.88074 6.26379 7.24336 6.1098 7.66013 6.11028C8.0769 6.11028 8.4394 6.2644 8.74762 6.57262L16 13.825L23.2524 6.57262C23.5606 6.2644 23.9232 6.1104 24.3402 6.11065C24.7575 6.11065 25.1202 6.26476 25.4285 6.57298C25.7369 6.88145 25.8909 7.24407 25.8904 7.66084C25.8904 8.07761 25.7363 8.44011 25.4281 8.74833L18.1757 16.0007L25.4281 23.2531C25.7363 23.5613 25.8903 23.9239 25.8901 24.3409C25.8901 24.7582 25.736 25.1209 25.4277 25.4292C25.1193 25.7376 24.7566 25.8916 24.3399 25.8911C23.9231 25.8911 23.5606 25.737 23.2524 25.4288L16 18.1764L8.74762 25.4288C8.4394 25.737 8.07678 25.891 7.65977 25.8908C7.24251 25.8908 6.87977 25.7367 6.57155 25.4284C6.26308 25.12 6.10909 24.7574 6.10957 24.3406C6.10957 23.9238 6.26368 23.5613 6.57191 23.2531L13.8243 16.0007Z"
        :fill="color"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "IconCrossWaitingSidebar",
  props: {
    color: {
      type: String,
      default: "#F18E35",
    },
  },
};
</script>

<style scoped></style>
